// React&NextJS
import React, { useState } from 'react'
// Styles
import s from '../Authentication.module.scss'
import c from 'classnames'
// Components
import { Button } from '../../../core/button/Button'
import { Container } from '../../../core/container/Container'
import { Input } from '../../../core/input/Input'
import { Text } from '../../../core/text/Text'
import { WhiteBox } from '../../../core/whiteBox/WhiteBox'
import EmailPreferences from '../../emailPreferences/EmailPreferences'

const EmailComponent = ({
    closeButton = null,
    user,
    setUser,
    auth,
    ssn,
    cToken,
    setState,
    updateUserEmail,
    logInWithToken,
}) => {
    const [email, setEmail] = useState(user?.email || '')
    const [oldSettings] = useState(null)
    const [settings, setSettings] = useState({
        condAnnouncements: true,
        obitAnnouncements: true,
        mailAnnouncements: false,
        annoAnnouncements: true,
    })
    const [emailError, setEmailError] = useState('')
    const [emailLoad, setEmailLoad] = useState(false)
    const [termsAccepted, setTermsAccepted] = useState(false)

    const updateEmail = async () => {
        try {
            setState(3)
            if (user) {
                const ret = await updateUserEmail(email, settings, oldSettings)

                // if user is signed in but does not have email verified
                if (ret.updated && !user.email) {
                    // TODO: refresh usercontext
                    auth.currentUser.reload()
                    setUser({ ...user, email: email })
                } else if (!ret.updated) {
                    if (ret.error.message.includes('auth/invalid-email')) {
                        setEmailError('Vinsamlegast sláðu inn gilt netfang.')
                        setEmailLoad((prev) => !prev)
                        setState(2)
                    } else if (
                        ret.error.message.includes('auth/email-already-in-use')
                    ) {
                        setEmailError('Netfang er nú þegar í notkun.')
                        setEmailLoad((prev) => !prev)
                        setState(2)
                    } else {
                        // TODO: Viljum við ekki reyna að sleppa við eins margar auðkenningar og hægt er?
                        setEmailLoad((prev) => !prev)
                        setState(0)
                    }
                }
            } else {
                // when logging in for the first time this code block runs
                // This updates the email in firebase and in sendgrid

                const res = await fetch('/api/auth/email', {
                    method: 'POST',
                    body: JSON.stringify({
                        email: email,
                        ssn: ssn,
                        settings: settings,
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                })

                if (res.ok) {
                    // Send welcome email to user
                    fetch('/api/email/mailList', {
                        method: 'POST',
                        body: JSON.stringify({
                            email: email,
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                    })
                    // If user is newly signed in then log him in
                    await logInWithToken(cToken)
                } else {
                    const response = await res
                        .json()
                        .catch((err) => console.log(err))

                    throw new Error(response.message)
                }
            }
        } catch (error) {
            console.error(error.message)

            setEmailError(error.message)
            setEmailLoad((prev) => !prev)
            setState(2)
        }
    }

    const emailBtn = () => (
        <Button
            id="emailBtn"
            onClick={() => {
                setEmailLoad((prev) => !prev)
                setEmailError('')
                updateEmail()
            }}
            className={s.button}
            disabled={emailLoad || email.length === 0 || !termsAccepted}
            aria-disabled={emailLoad || email.length === 0 || !termsAccepted}
        >
            Áfram
        </Button>
    )

    return (
        <Container>
            <WhiteBox className={s.container}>
                {closeButton}
                <div>
                    <Text variant="h2">Skráðu netfangið þitt</Text>
                    <Text variant="p-18">
                        Við notum það til að senda þér mikilvægar upplýsingar um
                        þín mál.
                    </Text>
                    <Input
                        placeholder="Netfang"
                        type="email"
                        value={email}
                        errorMsg={emailError}
                        disabled={emailLoad}
                        aria-disabled={emailLoad}
                        className={c(
                            s.input,
                            s.input__2,
                            emailError && s.inputError
                        )}
                        onChange={(e: React.BaseSyntheticEvent) => {
                            if (emailError) {
                                setEmailError('')
                            }
                            setEmail(e.currentTarget.value)
                        }}
                    />
                    <EmailPreferences
                        settings={settings}
                        setSettings={setSettings}
                        terms={termsAccepted}
                        setTerms={setTermsAccepted}
                        newAuth={true}
                        className={emailLoad ? 'checkBoxDisabled' : ''}
                    />
                </div>
                {emailBtn()}
            </WhiteBox>
        </Container>
    )
}

export default EmailComponent
